import Vue from "vue";
import form from "~/mixins/form";

Vue.mixin(form);
